<template>
    <div>
        <div class="card" v-if="sesion">
            <div class="card-header">
                <div class="text-center text-lg-left">
                    <div class="d-flex flex-column flex-md-row justify-content-md-between">
                        <h3 class="card-title my-3">
                            Entradas para la sesión: {{ sesion.fecha }}
                        </h3>
                        <div class="d-flex flex-column flex-md-row align-items-stretch pt-0 pt-md-1">
                            <Button
                                class="m-1"
                                @click.prevent="showModal('cargarPrecios')"
                            >
                                Cargar precios de otro evento / sesión
                            </Button>
                            <CargarPrecios
                                :sesion="sesion"
                                :evento_id="evento_id"
                                v-on:close="closeModal"
                            />
                            <Button
                                class="m-1"
                                @click.prevent="showModal('crearEntrada')"
                            >
                                Crear nueva entrada
                            </Button>
                            <CreateModal
                                :sesion="sesion"
                                :evento_id="evento_id"
                                v-on:close="closeModal"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div class="card-body">
                <div class="row">
                    <div class="col-12">
                        <div>
                            <template v-for="(entrada, index) in entradas">
                                <div
                                    class="row mb-4"
                                    :key="index"
                                    :id="'entrada-' + entrada.id"
                                    v-if="entrada.zona != 'Invitación Protocolo'"
                                >
                                    <div class="col-6 col-md-10">
                                        <div class="row">
                                            <div class="col-12 col-md-4">
                                                <strong>{{ entrada.descripcion }}</strong>
                                            </div>
                                            <div class="col-12 col-md-4">
                                                <i class="text-green fas fa-laptop"></i>
                                                {{ entrada.price_management_online_interno ? parseFloat(entrada.precio) : (parseFloat(entrada.precio) + parseFloat(entrada.price_management_online)) | formatear_precio }}
                                            </div>
                                            <div class="col-12 col-md-4">
                                                <i class="text-green fas fa-store"></i>
                                                {{ entrada.price_management_taquilla_interno ? parseFloat(entrada.precio) : (parseFloat(entrada.precio) + parseFloat(entrada.price_management_taquilla)) | formatear_precio }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6 col-md-2">
                                        <OpcionesDropdownComponent
                                            v-bind:options="[
                                                {
                                                    type: 'action',
                                                    action: () => showModal('editarEntrada-' + entrada.id),
                                                    label: 'Editar',
                                                },
                                                {
                                                    type: 'action',
                                                    action: () => showModal('deleteEntrada-' + entrada.id),
                                                    label: 'Borrar',
                                                },
                                            ]"
                                        />
                                    </div>
                                    <EditarModal
                                        :evento_id="evento_id"
                                        :sesion="sesion"
                                        :entrada="entrada"
                                        v-on:close="closeModal"
                                    />
                                    <BorrarModal
                                        :evento_id="evento_id"
                                        :sesion_id="sesion.id"
                                        :entrada="entrada"
                                        v-on:close="closeModal"
                                    />
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div
            class="card card-primary card-outline card-outline-tabs"
            v-if="sesion"
        >
            <div class="card-header p-0 border-bottom-0">
                <ul
                    class="nav nav-tabs"
                    id="custom-tabs-five-tab"
                    role="tablist"
                >
                    <li class="nav-item">
                        <a
                            :class="tab == 'normal' ? 'nav-link active' : 'nav-link'"
                            href="#"
                            @click.prevent="tab = 'normal'"
                        >
                            Normal
                        </a>
                    </li>
                    <li class="nav-item">
                        <a
                            :class="tab == 'abonados' ? 'nav-link active' : 'nav-link'"
                            href="#"
                            @click.prevent="tab = 'abonados'"
                        >
                            Abonad@s
                        </a>
                    </li>
                    <li class="nav-item">
                        <a
                            :class="tab == 'acompanantes' ? 'nav-link active' : 'nav-link'"
                            href="#"
                            @click.prevent="tab = 'acompanantes'"
                        >
                            Acompañantes
                        </a>
                    </li>
                    <li class="nav-item">
                        <a
                            :class="tab == 'amigos' ? 'nav-link active' : 'nav-link'"
                            href="#"
                            @click.prevent="tab = 'amigos'"
                        >
                            Amig@s
                        </a>
                    </li>
                </ul>
            </div>
            <div class="card-body" v-if="!loading">
                <div class="tab-content">
                    <div class="tab-pane fade active show">
                        <transition name="fade" mode="out-in">
                            <div
                                key="1"
                                class="overlay-wrapper"
                                v-if="tab == 'normal'"
                            >
                                <EntradasNormal
                                    :evento_id="evento_id"
                                    :sesion="sesion"
                                    :precios="entradas"
                                />
                            </div>
                            <div
                                key="2"
                                class="overlay-wrapper"
                                v-if="tab == 'abonados'"
                            >
                                <EntradasAbonados
                                    :evento_id="evento_id"
                                    :sesion="sesion"
                                    :precios="entradas"
                                />
                            </div>
                            <div
                                key="3"
                                class="overlay-wrapper"
                                v-if="tab == 'acompanantes'"
                            >
                                <EntradasAcompnanates
                                    :evento_id="evento_id"
                                    :sesion="sesion"
                                    :precios="entradas"
                                />
                            </div>
                            <div
                                key="4"
                                class="overlay-wrapper"
                                v-if="tab == 'amigos'"
                            >
                                <EntradasAmigos
                                    :evento_id="evento_id"
                                    :sesion="sesion"
                                    :precios="entradas"
                                />
                            </div>
                        </transition>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CreateModal from './modals/CreateEntradaConRecinto'
    import EditarModal from './modals/EditarEntradaConRecinto'
    import BorrarModal from './modals/DeleteEntradaConRecinto'
    import CargarPrecios from './modals/CargarPrecios'
    import EntradasNormal from './Normal'
    import EntradasAbonados from './Abonados'
    import EntradasAcompnanates from './Acompanantes'
    import EntradasAmigos from './Amigos'
    import OpcionesDropdownComponent from '@/components/backend/components/OpcionesDropdownComponent'

    export default {
        props: ['evento_id', 'sesion_id'],
        data() {
            return {
                tab: 'normal',
                entradas: null,
                sesion: null,
                loading: false,
            }
        },
        created() {
            this.getSesion()
        },
        methods: {
            getSesion: function() {
                this.loading = true

                const params = {
                    filters: {},
                    evento_id: this.evento_id,
                    sesion_id: this.sesion_id,
                }

                this.$store.dispatch(
                    this.config.getVuexAlias('back.events.sesiones.show'),
                    params
                ).then(res => {
                    this.sesion = res.data.data
                    this.entradas = res.data.data.entradas
                }).finally(() => (this.loading = false))
            },
            showModal(modal) {
                this.$modal.show(modal)
            },
            closeModal(modal, creado) {
                if (creado) {
                    this.getSesion()
                    this.$modal.hide(modal)
                }
            },
        },
        components: {
            CreateModal,
            EditarModal,
            BorrarModal,
            EntradasNormal,
            EntradasAbonados,
            OpcionesDropdownComponent,
            CargarPrecios,
            EntradasAcompnanates,
            EntradasAmigos,
        },
    }
</script>
